import { createRouter, createWebHistory } from 'vue-router';
import { routes } from 'vue-router/auto-routes';

import { resolveNavigationTarget } from '@/router-guards';
import { useAuthStore } from '@/stores/auth.store';

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const authStore = useAuthStore();

  return resolveNavigationTarget(to, {
    isAuthenticated: authStore.isAuthenticated,
    roleConfig: authStore.roleConfig,
  });
});
